<template>
  <v-container>
    <v-card style="padding: 30px">
      <v-card-title
      >Kafedra {{ isNew ? "qo'shish" : "o'zgartirish" }}
      </v-card-title
      >
      <v-row>
        <v-spacer/>
        <v-col md="6" sm="12">
          <v-text-field
              v-model="department.name"
              label="NOMI"
              outlined
          ></v-text-field>
        </v-col>
        <v-col md="12" sm="12">
          <v-row>
            <v-btn
                class="mx white--text"
                color="light-blue"
                @click="$router.push('/department')"
            >
              <v-icon>mdi-arrow-left</v-icon>
              Ortga
            </v-btn
            >
            <v-spacer/>
            <v-btn class="mx" color="primary" @click="save()">Saqlash</v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular
          color="primary"
          indeterminate
      ></v-progress-circular>
    </v-overlay>
    <v-snackbar :value="snackbar" color="success" outlined right>
      id={{ department.id }} dagi kafedra muvaffaqiyatli saqlandi!!
    </v-snackbar>
  </v-container>
</template>
<script>
import service from "./department.service";


export default {
  data: () => ({
    overlay: false,
    department: {
      id: "",
      name: "",
      amountBooks: 0
    },
    snackbar: false,
  }),
  methods: {
    getEntity(id) {
      service.getOne(id).then((res) => {
        this.department = res.data;
      });
    },
    initials() {
      if (!this.isNew) {
        this.getEntity(this.$route.params.id);
      }
    },

    save() {
      this.overlay = true;
      service.save(this.department).then((res) => {
        this.department = res.data;
        this.overlay = false
        this.snackbar = true
      }).catch(() => {
        this.overlay = false;
      });
    },
  },
  created() {
    this.initials();
  },
  computed: {
    isNew() {
      return !this.$route.params.id;
    },
  },
};
</script>
